import * as Types from '../types-api.generated';

import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { apiFetcher } from 'lib/clients/graphql';

import { ClientError } from "graphql-request";
import { Address } from "viem";
import { ChainId } from "lib/chains";

export type ApiFollowVariables = Types.Exact<{
  accountAddress: Types.Scalars['ID'];
}>;


export type ApiFollow = { follow: boolean };



export const ApiFollowDocument = /*#__PURE__*/ `
    mutation Follow($accountAddress: ID!) {
  follow(accountAddress: $accountAddress)
}
    `;

export const useFollow = <
      TError = ClientError,
      TContext = unknown
    >(options?: UseMutationOptions<ApiFollow, TError, ApiFollowVariables, TContext>) => {
    
    return useMutation<ApiFollow, TError, ApiFollowVariables, TContext>(
      {
    mutationKey: ['Follow'],
    mutationFn: (variables?: ApiFollowVariables) => apiFetcher<ApiFollow, ApiFollowVariables>(ApiFollowDocument, variables)(),
    ...options
  }
    )};


useFollow.fetcher = (variables: ApiFollowVariables, options?: RequestInit['headers']) => apiFetcher<ApiFollow, ApiFollowVariables>(ApiFollowDocument, variables, options);
